export class Translator {
  constructor(options) {
    ({ translations: this.translations = {} } = options);
  }

  translate(key) {
    if (this.translations.hasOwnProperty(key)) {
      return this.translations[key];
    } else if (window.tp_trans) {
      return tp_trans.trans(key, key);
    } else {
      return key;
    }
  }
}
